// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__ZQ3s_","containerItemsCenter":"Skeleton_containerItemsCenter__3jxuY"};